<app-no-data-available [hasData] = '!!resources.dados'>
  <div class="row">

    <div class="col-12">
      <!-- TABELA -->
      <table class="table table-hover border-bottom mt-2">
        <caption>Tabela com lista de recarga certa</caption>
        <thead>
          <tr>
            <th scope="col" colspan="5"></th>
            <th scope="col" colspan="3" class="text-nowrap" >SEM RECARGA CERTA</th>
            <th scope="col" colspan="3" class="text-nowrap">COM RECARGA CERTA</th>
            <th scope="col"></th>
          </tr>
          <tr>
            <th scope="col" class="text-uppercase">Matrícula</th>
            <th scope="col" class="text-uppercase">beneficiário</th>
            <th scope="col" class="text-uppercase">CPF</th>
            <th scope="col" class="text-uppercase">código</th>
            <th scope="col" class="text-uppercase">benefício</th>
            <th scope="col" class="text-uppercase">QTDE.</th>
            <th scope="col" class="text-uppercase">UNIT.</th>
            <th scope="col" class="text-uppercase">TOTAL</th>
            <th scope="col" class="text-uppercase">QTDE.</th>
            <th scope="col" class="text-uppercase">UNIT.</th>
            <th scope="col" class="text-uppercase">TOTAL</th>
            <th scope="col" class="text-uppercase">ECONOMIA</th>

          </tr>
        </thead>
        <tbody>
          @for (info of resources.dados | paginate: { id: 'enderecos', itemsPerPage: itemsPerPage , currentPage: currentPage, totalItems: totalItems}; track info) {
            <tr>
              <td class="verde texto-tabela">{{info.matricula}}</td>
              <td class="verde texto-tabela">{{info.usuario}}</td>
              <td class="verde texto-tabela text-nowrap">{{info.cpf | cpf}}</td>
              <td>{{info.codProduto}}</td>
              <td>{{info.produto}}</td>
              <td class="verde">{{info.qtdSemRC}}</td>
              <td class="verde">{{info.valorUnitarioSemRC}}</td>
              <td class="verde">{{info.subtotalSemRC}}</td>
              <td class="verdeComRecarga">{{info.qtdComRC}}</td>
              <td class="verdeComRecarga">{{info.valorUnitarioComRC}}</td>
              <td class="verdeComRecarga">{{info.subtotalComRC}}</td>
              <td class="amarelo">{{info.valorEconomia}}</td>
            </tr>
          }
        </tbody>
      </table>

    </div>
  </div>


  <div class="row mt-4 ">
    <div class="col-3 mb-4">
      <app-select
        [value]="itemsPerPage"
        (valueChanges)="itemsPerPage = $event"
        name="itemsPerPageName"
        [options]="[
        {name : 'Exibir 5 Resultados' , value : '5'} , 
        {name : 'Exibir 10 Resultados' , value : '10'} ,
        {name : 'Exibir 15 Resultados' , value : '15'} ,
        {name : 'Exibir 20 Resultados' , value : '20'} 

        ]"
        optionValue="value"
        optionText="name">
      </app-select>
    </div>
    <div class="col-6 mb-4 text-center ps-0">
      <pagination-controls class="bg-danger ps-0" id="enderecos" (pageChange)="getPage($event)"
        (pageBoundsCorrection)="pageChanged($event)" directionLinks="true" autoHide="true"
        responsive="true" previousLabel="Anterior" nextLabel="Próximo"
        screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
        screenReaderCurrentLabel="Página">
      </pagination-controls>
    </div>
    <p class="texto-tabela col-3 text-nowrap text-end">
      <span>{{totalItems}}</span> Registros foram encontrados</p>
    </div>

  </app-no-data-available>